import { useCallback } from 'react';
import { useDeepCompareMemoize } from './useDeepCompareMemoize';

export function useDeepCompareCallback(
  callback: Function,
  dependencies: unknown[]
) {
  return useCallback(callback, useDeepCompareMemoize(dependencies));
}
